import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { X, Cookie } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      // Show banner after a short delay
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6 pointer-events-none">
      <Card className="max-w-4xl mx-auto p-4 sm:p-6 shadow-lg border-2 pointer-events-auto animate-in slide-in-from-bottom-5">
        <div className="flex items-start gap-4">
          <Cookie className="h-6 w-6 text-primary flex-shrink-0 mt-1" />
          <div className="flex-1">
            <h3 className="font-semibold text-lg mb-2">Cookie Notice</h3>
            <p className="text-sm text-muted-foreground mb-4">
              We use essential cookies to provide authentication and core functionality. 
              These cookies are necessary for the platform to work properly. By continuing to use our service, 
              you consent to our use of cookies as described in our{' '}
              <Link to="/privacy-policy" className="text-primary underline underline-offset-2">
                Privacy Policy
              </Link>.
            </p>
            {/* min-h-[48px] keeps the compact look but guarantees a 48px tap
                target (the sm/default Button sizes are 36-40px, which fails the
                Lighthouse tap-target audit). */}
            <div className="flex flex-wrap gap-3">
              <Button onClick={handleAccept} size="sm" className="min-h-[48px]">
                Accept
              </Button>
              <Button onClick={handleDecline} variant="outline" size="sm" className="min-h-[48px]">
                Decline
              </Button>
              <Link to="/privacy-policy" aria-label="Read our Privacy Policy">
                <Button variant="ghost" size="sm" className="min-h-[48px]">
                  Privacy Policy
                </Button>
              </Link>
            </div>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={handleDecline}
            aria-label="Close cookie notice"
            className="flex-shrink-0 min-h-[48px] min-w-[48px]"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default CookieConsent;
